import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Nav = Styled.nav`
max-width: 30rem;
background-color: ${color.primary};
padding: 2rem 4rem;
`;
const NavList = Styled.ul`
display: flex;
flex-direction: column;
& > *:first-child::before {background-color: transparent};
`;

const NavItem = Styled.li`
position: relative;
display: flex;
padding: 0;
&::before {
content: '';
position: absolute;
top: 20%;
transform: translateY(-55%);
left: -9px;
height: 100%;
width: 1px;
background-color: ${color.primaryAlt};
}
`;
const NavLink = Styled.a.attrs(({ href }) => ({
  href,
}))`
color: ${color.primaryAlt};
padding: 1rem 0;
padding-left: 2rem;
transition: 0.2s ease;
&:hover {color: var(--color-white)};
&:before {
content: '';
position: absolute;
top: 50%;
transform: translateY(-50%);
left: -18px;
height: 2rem;
width: 2rem;
border-radius: 100rem;
z-index: 4;
background-color: ${color.primaryAlt};
border: 5px solid transparent;
transition: 0.2s ease;
}
${(props) =>
  props.active &&
  `&:before{
left: -20.3px;
width: 2.5rem;
height: 2.5rem;
background-color: ${color.primary};
border: 5px solid ${color.white};
}`};
&:hover::before {
left: -20.3px;
width: 2.5rem;
height: 2.5rem;
background-color: ${color.primary};
border: 5px solid ${color.white};
}
`;

const SignUpProcess = ({ links }) => {
  return (
    <Nav>
      <NavList>
        {links.map((link) => (
          <NavItem>
            <NavLink active={link.active}>{link.label}</NavLink>
          </NavItem>
        ))}
      </NavList>
    </Nav>
  );
};

export default SignUpProcess;
